import {AfterViewInit, ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {LanguageSwitcherService} from 'app/core/services/language-switcher.service';
import {ChangeEventData} from 'app/shared/classes/custom-form-component';
import {DropDownOption} from 'app/shared/components/drop-down-list/drop-down-list.component';
import {BehaviorSubject} from 'rxjs';

const allLocales = [
    {label: 'Translations', value: 'dev', icon: 'ico ico-flag ico-flag-gb'},
    {label: 'English', value: 'en', icon: 'ico ico-flag ico-flag-gb'},
    {label: 'Русский', value: 'ru', icon: 'ico ico-flag ico-flag-ru'},
];

@Component({
    selector: 'language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrls: ['./language-switcher.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherComponent implements AfterViewInit {
    @Input() dropDownView: boolean;
    locales: Array<DropDownOption> = [];
    currentLocale: string;

    loading$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(private languageSwitcher: LanguageSwitcherService) {
        this.locales = allLocales.filter(option => this.languageSwitcher.availableLanguages.includes(option.value));
        this.currentLocale = this.languageSwitcher.language;
    }

    ngAfterViewInit() {
        if (!this.currentLocale) {
            this.languageSwitcher.changeLanguage('en');
        }
    }

    onLocaleChange({newValue: value}: ChangeEventData<string>) {
        this.loading$.next(true);
        this.languageSwitcher.changeLanguage(value);
    }
}
